var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4551C24.8366 32.4551 32 25.2916 32 16.4551C32 7.61852 24.8366 0.455078 16 0.455078C7.16344 0.455078 0 7.61852 0 16.4551C0 25.2916 7.16344 32.4551 16 32.4551Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1971 12.2813H19.1038C19.1211 12.5114 19.1309 12.7435 19.1309 12.9769C19.1309 14.5247 18.744 16.0249 18.0696 17.0928C17.8615 17.4221 17.5119 17.8873 17.0439 18.201V12.2812H14.957V18.201C14.489 17.8873 14.1393 17.4222 13.9313 17.0928C13.2568 16.0249 12.87 14.5247 12.87 12.9769C12.87 12.7435 12.8798 12.5113 12.8971 12.2813H10.8037C10.7903 12.5102 10.783 12.7421 10.783 12.9769C10.783 17.2679 13.0747 20.6291 16.0003 20.6291C18.9259 20.6291 21.2177 17.2679 21.2177 12.9769C21.2178 12.7421 21.2105 12.5102 21.1971 12.2813V12.2813Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60846 8.10727H8.6954V9.49858H10.7823V8.10727H12.8693V9.49858H14.9562V8.10727H17.0432V9.49858H19.1301V8.10727H21.217V9.49858H23.304V8.10727H25.3909V9.49858H30.412C27.8242 4.14664 22.3431 0.455078 15.9998 0.455078C9.65646 0.455078 4.1754 4.14664 1.5874 9.49858H6.60846V8.10727Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3911 23.4118V24.8031H23.3042V23.4118H21.2172V24.8031H19.1303V23.4118H17.0433V24.8031H14.9564V23.4118H12.8695V24.8031H10.7825V23.4118H8.6954V24.8031H6.60846V23.4118H1.5874C4.1754 28.7638 9.6564 32.4553 15.9998 32.4553C22.3432 32.4553 27.8242 28.7638 30.4122 23.4118H25.3911Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.455078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.a275b4f2.svg";
export { ForwardRef as ReactComponent };